export default {
  getPluginStatusValue (service) {
    let status = 0
    switch (service.serviceId) {
      case 1: // 流量サービスの場合
        const filter = service.filters[0] // TODO フィルタが１個しか付いていない前提での実装になっている。複数フィルタに対応するには実装の変更が必要。
        if ((filter.maxLifeSpanFlow > 0 && filter.flow > filter.maxLifeSpanFlow) ||
          (filter.maxLifeSpanTime > 0 && filter.time > filter.maxLifeSpanTime)) {
          status = 2
        } else if ((filter.warningLifeSpanFlow > 0 && filter.flow > filter.warningLifeSpanFlow) ||
          (filter.warningLifeSpanTime > 0 && filter.time > filter.warningLifeSpanTime)) {
          status = 1
        }
        break
      case 2: // ROサービスの場合
      case 3: // 温度サービスの場合
      case 4: // 漏水サービスの場合
      case 5: // 圧力値サービスの場合
        status = service.status
        break
      default:
    }
    return status
  },
  getServiceStatusValue (service) {
    const good = 0
    const warning = 1
    const alert = 2
    switch (service.serviceId) {
      case 1:
      case 2:
        return this.getPluginStatusValue(service)
      case 3:
      case 4:
      case 5:
        let status = good
        for (let portIndex = 0; portIndex < service.details.length; portIndex++) {
          let statusByPort = this.getPluginStatusValue(service.details[portIndex])
          if (statusByPort === warning) {
            status = warning
          }
          if (statusByPort === alert) {
            status = alert
            return status
          }
        }
        return status
      default:
        return good
    }
  },
  getFiltrationSystemStatusValue (filtrationSystem) {
    // サービス総じてのステータスのチェックを行う （本来はサーバでやったほうが良さそう）
    const good = 0
    const warning = 1
    const alert = 2
    let status = good
    if (filtrationSystem.services[0] == null) {
      return status
    }

    for (let service of filtrationSystem.services) {
      const statusByService = this.getPluginStatusValue(service)
      if (statusByService === warning) {
        status = warning
      }
      if (statusByService === alert) {
        status = alert
        return status
      }
    }

    // filtrationSystemのプロパティに追加する（そうしないとDOMに反映されない）
    return status
  },
  getCssClassForStatus (status, classSuffix = '') {
    const alertClass = 'red'
    const warningClass = 'orange'
    const goodClass = 'blue'
    let statusClass = goodClass
    switch (status) {
      case 1:
        statusClass = warningClass
        break
      case 2:
        statusClass = alertClass
        break
      case 0:
      default:
        statusClass = goodClass
    }
    return statusClass + classSuffix
  },
  getNotificationSettings (status) {
    const alertType = 'error'
    const warningType = 'warning'
    const alertMessageKey = 'home.notification-alert'
    const warningMessageKey = 'home.notification-warning'
    let notificationSettings = {
      type: '',
      messageKey: ''
    }
    switch (status) {
      case 1:
        notificationSettings = {
          type: warningType,
          messageKey: warningMessageKey
        }
        break
      case 2:
        notificationSettings = {
          type: alertType,
          messageKey: alertMessageKey
        }
        break
      case 0:
      default:
        notificationSettings = {
          type: '',
          messageKey: ''
        }
    }
    return notificationSettings
  }
}



// WEBPACK FOOTER //
// ./src/utils/statuscheck.js